module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1251.2af215fa.png";